/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type HotspotButtonIcon = (typeof HotspotButtonIcon)[keyof typeof HotspotButtonIcon]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotspotButtonIcon = {
  NONE: 'NONE',
  PLAY: 'PLAY',
  ARROW: 'ARROW',
  EXTERNAL: 'EXTERNAL',
} as const
